import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom'
import ForecastGraph from './ForecastGraph';

function ForecastContent(props) {
    const { id } = props;
    const [post, setPosts] = useState([])

    useEffect(() => {
        axios.get(`/api/places/${id}`)
        .then(res => {
            setPosts(res.data)
        })
    }, [])

    return (
      <div class="bl_contentInner">
        <div class="bl_innerForecast">
          <div class="bl_forecast">
            <div class="bl_forecastWeather">
              <div class="bl_forecastWeather_ttl">
                <div class="el_forecastWeather_logo">
                  <img src="/img/forecast_logo.png" alt="" />
                </div>
                <div class="el_forecastWeather_name">
                  <p>予報天候情報</p>
                </div>
              </div>
            </div>
            <div class="bl_forecastInfo">
              <div class="el_forecastInfo_inner">
                <ForecastGraph id={id} place={post.name}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default ForecastContent
